// application.js
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap";
import "./controllers";
import "./bulk_route";
import "./sidebar";
import "./offcanvas_forms";
import { initAddressLocationFilter } from "./address_location_filter";
import { initProfileFeatureSearch } from "./profile_feature_search";
import { initDashboardLayout } from "./dashboard_layout";
import { initOccurrenceReasonsOrder } from "./occurrence_reasons_order";
import $ from "jquery"
import moment from "moment";
import "bootstrap-daterangepicker"
import Inputmask from "inputmask"

window.$ = $
window.jQuery = $
window.moment = moment
window.bootstrap = bootstrap

$(function () {
  $('#daterange').daterangepicker({
    locale: {
      format: 'DD/MM/YYYY'
    }
  })
})

import { initMap, wireRoutesButton } from "./leaflet_map";

// Sem Turbo: use DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  console.log("app DOMContentLoaded"); // debug
  initAddressLocationFilter();
  initMap();
  wireRoutesButton(); // liga o botão Rotas ao fetch + offcanvas
  initProfileFeatureSearch();
  initDashboardLayout();
  initOccurrenceReasonsOrder();
});

// Toastr (mantém como já estava)
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".toast").forEach((toastEl) => {
    const toast = new bootstrap.Toast(toastEl, { delay: 4000 });
    toast.show();
  });
});

document.addEventListener("turbo:load", () => {
  initProfileFeatureSearch();
  initDashboardLayout();
  initOccurrenceReasonsOrder();
});
